var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wgu-module-card',_vm._b({staticClass:"wgu-layerlist",attrs:{"moduleName":"wgu-layerlist","icon":_vm.icon}},'wgu-module-card',_vm.$attrs,false),[_c('wgu-layerlist',{attrs:{"showLegends":_vm.showLegends,"showOpacityControls":_vm.showOpacityControls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }